var baseUrl = $("meta[name=js_base_url]").attr("content");

// function preloader
function prolloader() {
    if ($('body').children('.prelloader-box').length < 1) {
        $('body').append('<div class="prelloader-box"><div class="prelloader-spin"><i class="fa fa-spinner fa-spin"></i></div></div>');
    }
}

function removeProlloader() {
    setTimeout(function () {
        $('body').children('.prelloader-box').remove();
    }, 2000);
}

$(document).on('click', '.promotion__checkbox', function () {
    prolloader();

    $.post(baseUrl + 'shop/cart/promo/', {
        _csrf: $('#token').val(),
        promo: ($(this).is(":checked") ? 1 : 0),
        PromoUID: $(this).closest('.promotion').find('input[name=PromoUID]').val()
    }).done(function (data) {
        if (data) {
            refresh_full_cart();
        }
        removeProlloader();
    });
});

/**
 * Клик по карточке товара
 */
$('.js_select_item').on('click', function () {
    var id = $(this).data('id');

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: 'select_item',
        ecommerce: {
            items: [ecommerce_items[id]]
        }
    });
});

function pushAddToCartDataLayer(response, count, itemListName) {
    if (!response || !response.ecommerce || !Array.isArray(response.ecommerce.items)) {
        return;
    }

    var ecommerce = response.ecommerce;
    ecommerce.items = ecommerce.items.map(function (item) {
        item.quantity = Number(count || item.quantity || 1);
        if (itemListName) {
            item.item_list_id = itemListName;
            item.item_list_name = itemListName;
        }
        if (item.price !== undefined) {
            item.price = Number(item.price);
        }
        return item;
    });
    ecommerce.value = Number(ecommerce.value || 0);
    ecommerce.currency = ecommerce.currency || 'UAH';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: ecommerce
    });
}

/**
 * Кнопка купить в корзине
 */
$('.card-buy-special').on('click', function () {
    var id = $(this).data('id');
    var name = $(this).data('name');
    var discount = $(this).data('discount');
    var count = 1;

    $.post(baseUrl + 'shop/cart/add-to-cart/', {
        _csrf: $('#token').val(),
        id: id,
        count: count,
        discount: discount
    }).done(function (data) {
        if (data.success == true) {
            pushAddToCartDataLayer(data, count, typeof jst_item_list_name !== 'undefined' ? jst_item_list_name : '');

            document.location.reload(true);
        }
    }, 'json');
});

/**
 * Кнопка купить
 */
$('.card-buy-quantity').on('click', function () {
    var id = $(this).data('id');
    var name = $(this).data('name');
    var quantity = $(this).data('quantity');

    if (Array.isArray(id) && Array.isArray(quantity)) {
        for (var i = 0; i < id.length; i++) {
            add_to_popup(id[i], quantity[i], name[i]);
        }
    }

    $('#basket-popup').modal('show');
    // $('#overlay').fadeIn(400, function () {
            // .css('visibility', 'visible')
            // .animate({opacity: 1}, 200);
    // });
});

/**
 * Кнопка купить товары в анкете
 */
$('.card-buy-quantity-program').on('click', function () {
    var id = $(this).data('id');
    var name = $(this).data('name');
    var quantity = $(this).data('quantity');
    var questionnaire_form_id = $(this).data('questionnaire_form_id');
    var month = $(this).data('month');

    $.post(baseUrl + 'shop/cart/check-programs-in-cart/', {
        _csrf: $('#token').val()
    }).done(function (data) {
        if (data == true) {
            alert('У Вас в корзине уже есть товары из Welness-программы, ' +
                'отправте этот заказ и после этого Вы сможете добавить в ' +
                'корзину товары из другой Welness-программы.');
        } else {
            if (Array.isArray(id) && Array.isArray(quantity)) {
                for (var i = 0; i < id.length; i++) {
                    if (quantity[i] > 0) {
                        add_to_cart_program(id[i], quantity[i], questionnaire_form_id, month, name[i]);
                    }
                }
            }
            $('#basket-popup').modal('show');
            // $('#overlay').fadeIn(400, function () {
                    // .css('visibility', 'visible')
                    // .animate({opacity: 1}, 200);
            // });
        }
    });
});

$('#product_count_plus').on('click', function () {
    var count = $(this).parent().find('#product_count').val();
    count++;
    $('#product_count').val(count);
    $('.card-buy').data('count', count);
});

$('#product_count_minus').on('click', function () {
    var count = $(this).parent().find('#product_count').val();
    if (count > 1) {
        count--;
        $('#product_count').val(count);
    }
    $('.card-buy').data('count', count);
});

$(document)
.on('click', '.promo-product-card .card_img, .promo-product-card .card_t', function (event) {
    event.preventDefault();
    showPromoProductModal($(this).closest('.promo-product-card'), $(this).attr('href'), false);
})
.on('click', '.promo-product-card .card-buy', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    showPromoProductModal($(this).closest('.promo-product-card'), null, true);
})
.on('click', '.card-buy', function () {
    var id = $(this).data('id');
    var count = $(this).data('count') || 1;
    var name = $(this).data('name');
    // console.log("card-buy clicked", id, count, name);
    if ($(this).closest('.basket-recommend-product').length) {
        add_to_cart(id, count, name);
        refresh_full_cart();
    } else {
        add_to_popup(id, count, name);
        refresh_full_cart();
        // add_to_list(id, count, name);

        $('#basket-popup').modal('show');
        // $('#overlay').fadeIn(300, function () {
        // .addClass('opened')
        // .css('visibility', 'visible')
        // .animate({opacity: 1}, 150);
        // });
    }
});

function showPromoProductModal(card, url, isBuy) {
    var text = window.promoProductTranslations || {};
    var section = card.closest('.section-product-promo');
    var relations = section.data('promo-relations') || {};
    var productId = card.find('.card-buy').data('id');
    var relation = relations[productId];

    if (!relation) {
        return;
    }

    var title = $('<div>').text(relation.conditionTitle).html();
    var image = isBuy && relation.conditionImage ? '<img class="promo-condition-image" src="' + relation.conditionImage + '" alt="' + title + '">' : '';
    var actions = isBuy
        ? '<button class="btn-default promo-add-set" data-product-id="' + productId + '" data-condition-id="' + relation.conditionId + '">' + text.addSet + '</button>' +
          '<button class="btn-light-w-border promo-add-regular" data-product-id="' + productId + '">' + text.addRegular + '</button>'
        : '<button class="btn-default promo-view-with-condition" data-condition-id="' + relation.conditionId + '" data-url="' + encodeURIComponent(url) + '">' + text.addAndView + '</button>' +
          '<a class="btn-light-w-border" href="' + url + '">' + text.viewRegular + '</a>';

    $('#popup .content-body').html(
        '<div class="promo-product-modal">' + image +
        '<div class="wrapper-title">' + text.title + '</div>' +
        '<div class="wrapper-description">' + text.message + ' <strong>' + title + '</strong></div>' +
        '<div class="promo-product-modal-actions">' + actions + '</div></div>'
    );
    bootstrap.Modal.getOrCreateInstance(document.getElementById('popup')).show();
}

function addPromoProduct(productId, conditionId, redirectUrl) {
    $.post(baseUrl + 'shop/cart/add-to-cart/', {_csrf: $('#token').val(), id: conditionId, count: 1})
        .done(function () {
            if (!productId) {
                window.location.href = redirectUrl;
                return;
            }
            $.post(baseUrl + 'shop/cart/add-to-cart/', {_csrf: $('#token').val(), id: productId, count: 1})
                .done(function () {
                    refresh_short_cart();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('popup')).hide();
                    if (redirectUrl) window.location.href = redirectUrl;
                    else $('#basket-popup').modal('show');
                });
        });
}

$(document).on('click', '.promo-add-set', function () {
    addPromoProduct($(this).data('product-id'), $(this).data('condition-id'));
}).on('click', '.promo-add-regular', function () {
    add_to_popup($(this).data('product-id'), 1);
    bootstrap.Modal.getOrCreateInstance(document.getElementById('popup')).hide();
}).on('click', '.promo-view-with-condition', function () {
    addPromoProduct(null, $(this).data('condition-id'), decodeURIComponent($(this).data('url')));
});

/**
 * добавление в попап корзину
 */
function add_to_popup(id, count, name) {
    count = count || 1;
    name = name || 'Product 1';
    console.log("add_to_popup", id, count, name);

    $.post(baseUrl + 'shop/cart/add-to-cart/', {
        _csrf: $('#token').val(),
        id: id,
        count: count
    }).done(function (data) {
        // console.log("add_to_popup DONE: ", data);
        if (data.success == true) {
            pushAddToCartDataLayer(data, count, typeof jst_item_list_name !== 'undefined' ? jst_item_list_name : '');

            refresh_popup_cart();
        }
    }, 'json');
}

/**
 * добавление в корзину
 */
function add_to_cart(id, count, name) {
    count = count || 1;
    name = name || 'Product 1';
    console.log("add_to_cart", id, count, name);

    $.post(baseUrl + 'shop/cart/add-to-cart/', {
        _csrf: $('#token').val(),
        id: id,
        count: count
    }).done(function (data) {
        if (data.success == true) {
            pushAddToCartDataLayer(data, count, typeof jst_item_list_name !== 'undefined' ? jst_item_list_name : '');

            refresh_full_cart();
        }
    }, 'json');
}

/**
 * добавление в корзину программы
 */
function add_to_cart_program(id, count, questionnaire_form_id, month, name) {
    count = count || 1;
    month = month || 0;
    name = name || 'Product 1';

    $.post(baseUrl + 'shop/cart/add-to-cart/', {
        _csrf: $('#token').val(),
        id: id,
        count: count,
        questionnaire_form_id: questionnaire_form_id,
        month: month
    }).done(function (data) {
        if (data.success == true) {
            pushAddToCartDataLayer(data, count, typeof jst_item_list_name !== 'undefined' ? jst_item_list_name : '');

            refresh_popup_cart();
        }
    }, 'json');
}

/**
 * удаление елемента из корзины
 */
function delete_from_cart(id, count, name) {
    count = count || 0;
    name = name || 'Product 1';

    $.post(baseUrl + 'shop/cart/delete-from-cart/', {
        _csrf: $('#token').val(),
        product_id: id,
        count: count
    }).done(function (data) {
        if (data) {
            $.post(baseUrl + 'catalog/product/ecommerce-item/', {_csrf: $('#token').val(), id: id}, function (data) {
                console.log(data);
                if (data.success == true) {
                    data.product.quantity = count;
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: 'remove_from_cart',
                        ecommerce: {
                            items: [data.product]
                        }
                    });
                }
            });

            refresh_full_cart();
        }
    });
}

/**
 * удаление елемента из попапа корзины
 */
function delete_from_popup(id, count, name) {
    count = count || 0;
    name = name || 'Product 1';

    $.post(baseUrl + 'shop/cart/delete-from-cart/', {
        _csrf: $('#token').val(),
        product_id: id,
        count: count
    }).done(function (data) {
        if (data) {
            $.post(baseUrl + 'catalog/product/ecommerce-item/', {_csrf: $('#token').val(), id: id}, function (data) {
                console.log(data);
                if (data.success == true) {
                    data.product.quantity = count;
                    if (dataLayer !== undefined) {
                        dataLayer.push({ecommerce: null});
                        dataLayer.push({
                            event: 'remove_from_cart',
                            ecommerce: {
                                items: [data.product]
                            }
                        });
                    }
                }
            });

            refresh_popup_cart();
            refresh_full_cart();
        }
    });
}

/**
 * удаление елемента из корзины
 */
function delete_program_from_cart(id, url) {
    $.post(baseUrl + 'shop/cart/delete-program-from-cart/', {
        _csrf: $('#token').val(),
        questionnaire_form_id: id
    }).done(function (data) {
        if (data) {
            refresh_full_cart();
        }
    });

    answerHistory(url, 'remove_program_from_cart', id);
}

/**
 * удаление елемента из попапа корзины
 */
function delete_program_from_popup(id) {
    $.post(baseUrl + 'shop/cart/delete-program-from-cart/', {
        _csrf: $('#token').val(),
        questionnaire_form_id: id
    }).done(function (data) {
        if (data) {
            refresh_popup_cart();
        }
    });
}

/**
 * изменение количества елемента в корзины
 */
function change_count_cart_item(id, value, count, name) {
    if (isNumeric(value)) {
        var f_count = (count - value);

        if (f_count != 0 && f_count > 0) {
            delete_from_cart(id, f_count, name);
        } else if (f_count != 0 && f_count < 0) {
            add_to_cart(id, -f_count, name);
        }
    }
}

var delayTimeout;

/**
 * изменение количества с задержкой (нужно при заполнении с клавиатуры)
 */
function delay_change_count_cart_item(event, delay) {
    var el = $(event.target);

    var value = el.attr("value");
    var id = el.attr("data-id");
    var name = el.attr("data-name");
    var count = el.val();

    clearTimeout(delayTimeout);
    delayTimeout = setTimeout(function () {
        change_count_cart_item(id, count, value, name);
    }, delay);
}

/**
 * изменение количества елемента в попапе корзины
 *
 * @param event
 * @param delay
 */
function delay_change_count_cart_popup_item(event, delay) {
    var el = $(event.target);

    var value = el.attr("value");
    var id = el.attr("data-id");
    var name = el.attr("data-name");
    var count = el.val();

    clearTimeout(delayTimeout);
    delayTimeout = setTimeout(function () {
        change_count_cart_popup_item(id, count, value, name);
    }, delay);
}

/**
 * @inheritDoc
 *
 * @param id
 * @param value
 * @param count
 */
function change_count_cart_popup_item(id, value, count, name) {
    var value = +value;

    if (isNumeric(value)) {
        var f_count = (count - value);
        if (f_count != 0 && f_count > 0) {
            delete_from_popup(id, f_count, name);
        } else if (f_count != 0 && f_count < 0) {
            add_to_popup(id, -f_count, name);
        }
    }
}

/**
 * @inheritDoc
 */
function refresh_popup_cart() {
    $.post(baseUrl + 'shop/widget/', {
        _csrf: $('#token').val(),
        view: 'full_popup'
    }).done(function (data) {
        console.log("refresh_popup_cart DONE");
        if (data.success) {
            //doing something
            $('#basket-popup .short_cart').html(data.views.short);
            // $('#basket-popup .header-mobile_r').html(data.views.short_mobile);
            $('#basket-popup .content-body').html(data.view);
            refresh_short_cart();
            my_scrol();
            tabs.init();
        }
    });
}

/**
 * @inheritDoc
 */
function refresh_full_cart() {
    $.post(baseUrl + 'shop/widget/', {
        _csrf: $('#token').val(),
        view: 'full_tabs'
    }).done(function (data) {
        console.log("refresh_full_cart");
        if (data.success) {
            console.log("refresh_full_cart success");
            $('.short_cart').html(data.views.short);
            // $('.header-mobile_r').html(data.views.short_mobile);
            $("body").find("#basketItemsList").replaceWith(data.view);
            if (window.initAmritaSwipers) {
                window.initAmritaSwipers(document.getElementById('basketItemsList'));
            }
            refresh_short_cart();
            discountPercents(20, 10, 30, 4);
            tabs.init();
        }
    });
}


function refresh_short_cart() {
    $.ajax({
        url: baseUrl.replace('/ua/', '/') + 'shop/widget/get-cart-info/',
        type: 'POST',
        data: {
            '_csrf': $('#token').val()
        },
        success: function (data) {
            // console.log({data});
            if (data.success == 1) {
                if (+data.totalCount <= 0) {
                    $('.basket-count').hide();
                } else {
                    $('.basket-count').show().html(data.totalCount);
                }
                $('#basket-popup .basket-sm_count span').html(data.totalCount);
                $('#basket-popup .basket-price').html(data.totalSumm);
                $('#basket-popup .basket-sm_count').html(data.totalCount);
                $('#basket-popup .basket-sm_amount span').html(data.totalSumm);
                $('#basket-popup .quiz_basket_total_price').html(data.totalSumm + '&nbsp;<span>грн</span>');
                $('#basket_total_cost .basket_total_price').html('<span class="for-totalsum">' + data.totalSumm + '</span>&nbsp;<span>грн</span>');
                $('.cart-total .basket_total_price').html(data.totalSumm + '&nbsp;<span>грн</span>');
                // $('.summary-price').html(data.totalSumm);

                // console.log(data.totalSumm);
                if (data.totalSumm) {
                    if (data.totalSumm < 2400) {
                        console.log("not enough");
                        const amnt = 2400 - Math.round(data.totalSumm);
                        $("#insufficientAmount").text(amnt)
                        $("#cartAlertInsufficient").show();
                    } else {
                        $("#cartAlertInsufficient").hide();
                    }
                }
            }
        },
        error: function (err) {
            console.log(err.statusText);
        }
    });
}

/**
 * @inheritDoc
 */
function close_popup_cart() {
    $('#basket-popup').modal('hide');
    // $('#basket-popup').animate({opacity: 0}, 150, function () {
    //     $(this).css('visibility', 'hidden').removeClass('opened');
    //     $('#overlay').fadeOut(300);
    // });
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * иницилизация скрола в попапе
 */
function my_scrol() {
    if ($('.basket-popup_cnt').exists()) {
        // $('.basket-popup_cnt').jScrollPane();

        var api = $('.basket-popup_cnt').data('jsp');
        var throttleTimeout;

        $(window).bind('resize', function () {
            if (!throttleTimeout) {
                throttleTimeout = setTimeout(
                    function () {
                        api.reinitialise();
                        throttleTimeout = null;
                    },
                    50
                );
            }
        });
    }
}

/**
 * изменения цвета иконки корзины, когда нет товаров
 */
$(document).ready(function () {
    refresh_short_cart();

    var cartCounter = $('.round-green'),
        cartCounterVal = cartCounter.text();

    if (cartCounterVal == 0) {
        $('.basket-sm').remove('other-icon');
    } else {
        $('.basket-sm').addClass('other-icon');
    }
});

/**
 * Tabs on cart
 */
var tabs = (function () {

    var init = function () {
        tabControlItem = document.querySelectorAll('.basket_tabs_controls-item');
        tabContents = document.querySelectorAll('.basket_tabs_list-item');

        _setUpListners();
    };

    var _setUpListners = function () {
        var existing = document.querySelector('.basket_tabs_cnt_cart') || document.querySelector('#basket-popup_cnt');

        if (existing) {
            Array.from(tabControlItem).forEach(function (item) {
                item.addEventListener('click', switchTabs);
            });
        }

    };

    var tabControlItem;
    var tabContents;

    function switchTabs(e) {
        if (e.target === this) {
            Array.from(tabControlItem).forEach(function (item, i) {
                item.classList.remove('active');
                tabContents[i].style.display = 'none';
                if (e.target === item) {
                    item.classList.add('active');
                    tabContents[i].style.display = 'block';
                }
            });
        }
    }

    return {
        init: init
    }
})();

var moreInfo = (function () {

    var init = function () {
        if (infoBtn) {
            _setUpListners();
        }

    };

    var _setUpListners = function () {
        infoBtn.addEventListener('click', _toggleOpen);
    };

    var infoBtn = document.querySelector('.note-more-btn');

    function _toggleOpen() {
        infoBtn.closest('.note-more').classList.toggle('opened');
    }

    return {
        init: init
    }
})();
moreInfo.init();

var sponsorTooltip = (function () {

    var init = function () {
        if (tooltip) {
            _setUpListners();
        }
    };

    var _setUpListners = function () {
        tooltip.addEventListener('mouseover', _toggleOpen);
        tooltip.addEventListener('mouseout', _toggleOpen);
    };

    var tooltip = document.querySelector('.sponsor-tooltip');

    function _toggleOpen() {
        if (this.classList.contains('active')) {
            tooltip.classList.remove('active');
            return false;
        }
        this.classList.add('active');
    }

    return {
        init: init
    }
})();
sponsorTooltip.init();
